<div class="document-body">
    <kendo-svg-icon [icon]="checkCircleIcon"></kendo-svg-icon>
    <h3 class="margin-bottom-20">
        {{ 'thanks-for-signing.label.title' | translate }}
    </h3>
    <label>
        {{ 'thanks-for-signing.label.paragraph-1' | translate }}
    </label>
    <label *ngIf="fileUrl">
        {{ 'thanks-for-signing.label.paragraph-2' | translate }}
        <a [href]="fileUrl" download="download.pdf"> {{ 'thanks-for-signing.label.download-document' | translate }}</a>
    </label>
</div>
